<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a href="/">Administration</a></li>
    <li class="breadcrumb-item"><a [routerLink]="['/externs']">Externes</a></li>
    <li class="breadcrumb-item active">Détail d'une compte externe</li>
  </ol>
</nav>

@if (extern) {
  <div class="row">
    <div class="col-sm-12 col-md-6">
      <nb-card>
        <nb-card-header class="with-button">Détail d'un compte externe</nb-card-header>
        <nb-card-body>
          @if (extern.isCoop && extern.logo) {
            <div style="float: right">
              <img
                [src]="uploadBaseUrl + extern.logo"
                alt="Logo"
                style="max-width: 200px; max-height: 200px"
                />
            </div>
          }
          <div class="form-group">
            <label>Nom</label>
            <div class="value">{{ extern.name }}</div>
          </div>
          <div class="form-group">
            <label>Types d'animaux gérés :</label>
            @for (animalType of animalTypes; track animalType) {
              <div class="animal-type-option">
                <nb-icon
              [icon]="
                isAnimalTypeSelected(animalType.id)
                  ? 'checkmark-circle-2-outline'
                  : 'close-circle-outline'
              "
                  [status]="isAnimalTypeSelected(animalType.id) ? 'success' : 'danger'"
                  >
                </nb-icon>
                {{ animalType.label }}
              </div>
            }
          </div>
          <hr />
          <div class="form-group">
            <label>Coop ?</label>
            <div class="value">{{ extern.isCoop ? "Oui" : "Non" }}</div>
          </div>
          @if (extern.isCoop) {
            <div class="form-group">
              <label>Mode d'affichage</label>
              <div class="value">{{ extern.coopDisplayMode == "FULL" ? "complet" : "limité" }}</div>
            </div>
          }
          @if (extern.isCoop) {
            <div class="form-group">
              <label>Thème CSS</label>
              <div class="value">{{ extern.cssTheme }}</div>
            </div>
          }
          <hr />
          <div class="form-group">
            <label>Type d'export</label>
            <div class="value">{{ extern.exportType }}</div>
          </div>
          @if (extern.exportType == 'FTP') {
            <div class="form-group">
              <label>Répertoire FTP</label>
              <div class="value">{{ extern.ftpPath }}</div>
            </div>
          }
          @if (extern.exportType == 'FTP') {
            <div class="form-group">
              <label>Format fichier FTP</label>
              <div class="value">{{ extern.ftpFileFormat }}</div>
            </div>
          }
          @if (extern.exportType == 'API') {
            <div class="form-group">
              <label>Clé Api</label>
              <div class="value">{{ extern.apikey }}</div>
            </div>
          }
          @if (extern.exportType == 'API') {
            <div class="form-group">
              <label>Date d'expiration</label>
              <div class="value">{{ extern.expirationDate | date: "dd/MM/yyyy" }}</div>
            </div>
          }
          <div class="form-group">
            <button
              nbButton
              fullWidth
              [disabled]="extern.isProtected"
              status="primary"
              class="mb-2"
              (click)="editAction()"
              >
              Modifier les informations
            </button>
            @if (extern.exportType == 'API') {
              <button
                nbButton
                fullWidth
                status="primary"
                class="mb-2"
                (click)="reloadApiAction()"
                >
                Renouveller la clé API
              </button>
            }
            <button
              nbButton
              fullWidth
              [disabled]="extern.isProtected"
              outline
              status="danger"
              (click)="deleteAction()"
              >
              Supprimer ce compte
            </button>
          </div>
        </nb-card-body>
      </nb-card>
    </div>
    <div class="col-sm-12 col-md-6">
      @if (extern.isCoop == true) {
        <nb-card>
          <nb-card-header class="with-button">Est la Coop des éleveurs suivants </nb-card-header>
          <nb-list>
            @if (!coopCompanies || coopCompanies.length == 0) {
              <nb-list-item>
                Aucun éleveur
              </nb-list-item>
            }
            @for (company of coopCompanies; track company) {
              <nb-list-item>
                <div class="content">
                  <a [routerLink]="['/companies', 'show', company.id]" class="content">
                    {{ company.name }}
                  </a>
                  @if (company.coopLinkedAt) {
                    <div class="text-muted small">
                      Liée le {{ company.coopLinkedAt | date: "dd/MM/yyyy" }}
                    </div>
                  }
                </div>
              </nb-list-item>
            }
          </nb-list>
        </nb-card>
      }
      <nb-card>
        <nb-card-header class="with-button"
          >Liste des éleveurs associés
          <button nbButton status="success" size="small" (click)="addAction()">Ajouter</button>
        </nb-card-header>
        <nb-list>
          @if (!extern.companies || extern.companies.length == 0) {
            <nb-list-item>
              Aucun éleveur
            </nb-list-item>
          }
          @for (company of extern.companies; track company) {
            <nb-list-item>
              <div class="content">
                <a [routerLink]="['/companies', 'show', company.id]" class="content">
                  {{ company.name }}
                </a>
                @if (company.linkedAt) {
                  <div class="text-muted small">
                    Lié le {{ company.linkedAt | date: "dd/MM/yyyy" }}
                  </div>
                }
              </div>
              <div>
                <button
                  nbButton
                  status="primary"
                  class="transparent-button"
                  size="small"
                  (click)="deleteCompanyAction(company)"
                  >
                  <nb-icon icon="trash-outline"></nb-icon>
                </button>
              </div>
            </nb-list-item>
          }
        </nb-list>
      </nb-card>
    </div>
  </div>
}
